// import { minStyle } from '../../../constants/global'
import { forwardRef } from 'react';
import styled from 'styled-components';

import { Hvc } from '../components';
import { RefreshComponent } from '../Refresh';
import TextPrompt from '../text-prompt';
import type { ISelect } from './utils';

// eslint-disable-next-line react/display-name
export const TypeSelect = forwardRef(
	({ label, error, optionsdata, initoption, load, disableInit, cta, refreshProps, minComponent, ...props }: ISelect, ref) => (
		<TypeSelectStyle style={{ width: props.customwidth || '' }}>
			<div className='form-container f-column-9'>
				<Hvc
					removeDOM
					view={!!label}
					className='f-row-20 align-items-center'
				>
					<label
						className='m-0'
						htmlFor={props.id || props.name}
					>
						{label}
					</label>
					<Hvc
						removeDOM
						view={!!refreshProps}
					>
						<RefreshComponent
							load={refreshProps?.load}
							onRefresh={refreshProps?.onRefresh}
						/>
					</Hvc>
				</Hvc>
				<select
					ref={ref as React.LegacyRef<HTMLSelectElement> | undefined}
					{...props}
					className={`${error ? 'is-error' : ''} ${props.className} ${minComponent ? 'min-size' : ''}`}
					// style={minStyle(minComponent)}
				>
					<option
						disabled={disableInit}
						value={initoption.value}
					>
						{initoption.label}
					</option>
					{optionsdata
						?.filter((i) => !i.hide)
						?.map((i) => (
							<option
								key={i.id}
								value={i.value}
							>
								{i.label}
							</option>
						))}
				</select>
				{!!error && (
					<TextPrompt
						prompt={error}
						status={false}
					/>
				)}
			</div>
		</TypeSelectStyle>
	)
);

const TypeSelectStyle = styled.div`
	select {
		width: 100%;
		height: 2.5rem;
		border-radius: 0.625rem;
		flex-shrink: 0;
		background: #fff;
		padding: 0 2.2rem 0 0.8rem;
		font-size: 0.8125rem;
		box-shadow: none;
		box-sizing: border-box;
		outline: none;
		border: 1px solid var(--border-secondary, #eeeeee);
		appearance: none;
		background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M5 7.5L10 12.5L15 7.5' stroke='%23616161' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");
		background-repeat: no-repeat;
		background-position: right 0.75rem center;
		transition:
			border-color 0.2s ease,
			box-shadow 0.2s ease;

		&::placeholder {
			color: var(--input-placeholder, #a1a1a1);
			font-size: 0.8125rem;
			font-style: normal;
			font-weight: 300;
			line-height: normal;
		}

		&:focus {
			border-color: var(--color-primary, #1b6b4a);
			box-shadow: 0 0 0 3px rgba(27, 107, 74, 0.12);
			&.is-error {
				border-color: #f56e9d;
				box-shadow: 0 0 0 3px rgba(245, 110, 157, 0.18);
			}
		}

		&.is-error {
			border: 1px solid #f56e9d;
			margin-bottom: 0.81rem;
		}

		&.min-size {
			font-size: 12px;
			height: 36px;
			border: 1px solid var(--border-secondary, #eeeeee);
			border-radius: 10px;

			@media (max-width: 768px) {
				font-size: 16px;
			}
		}

		@media (max-width: 768px) {
			font-size: 16px;
		}
	}
	/* Override autofill styles for webkit browsers */
	select:-webkit-autofill {
		-webkit-box-shadow: 0 0 0 1000px var(--input-bg, #f0f0f0) inset !important; /* Override white background */
		-webkit-text-fill-color: var(--text-primary, #000); /* Set text color to override autofill styling */
	}
`;
